import dayjs from "dayjs";

const calculateDateDiff = (arriving: string, leaving: string) =>
  dayjs(leaving).diff(arriving, "days");

export default calculateDateDiff;
